import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable()
export class AuthPassService {
    constructor(
        public auth: AuthService,
        public router: Router) { }

    async canActivate(): Promise<boolean> {
        await this.auth.isAuthenticated();
        
        return true;
    }
}
